var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4496 13.0469L12.0703 9H8.1875V6.37391C8.1875 5.26676 8.73 4.1875 10.4691 4.1875H12.2344V0.742188C12.2344 0.742188 10.6323 0.46875 9.10051 0.46875C5.90266 0.46875 3.8125 2.40688 3.8125 5.91563V9H0.257812V13.0469H3.8125V22.8299C4.52535 22.9418 5.2557 23 6 23C6.7443 23 7.47465 22.9418 8.1875 22.8299V13.0469H11.4496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.64876f1806d82ea3a866bbcdd7628579.svg";
export { ForwardRef as ReactComponent };